import type { Column } from "./SortableTable";

/**
 * Long or short, as a sortable column. Read from the rules behind the row; a
 * row that names no direction is long, as the engine treats it.
 */
export function directionColumn<T extends { direction?: string | null }>(): Column<T> {
  return {
    key: "direction",
    label: "Direction",
    render: (r) => (r.direction === "short" ? "Short" : "Long"),
    sortValue: (r) => (r.direction === "short" ? "short" : "long"),
    firstDirection: "asc",
  };
}
